// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_73-3";
export var contentContainer = "_73-0";
export var editorContainer = "_73-1";
export var quillInputForm = "_73-2";
export var zoneDivider = "_73-4";